import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Mansoor Majeed </span>
            from <span className="purple"> kochi, kerala, India.</span>
            <br />Studying B.tech at KMEA Engg. collage . 
              I am currently Working on Personal Portfolio website Using React.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Playing football and Cricket
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Listen music
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Travelling and experience new Taste
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "DO what U Love 
            Love what U DO!"{" "}
          </p>
          <footer className="blockquote-footer">Mansoor Majeed</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
